import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom"; 
import ConfirmApprovedModel from "./ConfirmApprovedModel";
import ConfirmRejectModel from "./ConfirmRejectModel";

const token = localStorage.getItem('authToken');

class EditJobs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: "",
      userName: "",
      title: "",
      category: "",
      areaInput: "",
      categoryId: '', 
      categoryData: [],
      currentImageUrl: null,
      submissionStatus: null,
      submeet: false,
      errors: [],
      date: "",
      salary: "",
      showModal: false,
      selectedCategoryId: null,
      showModalReject: false,
      selectedCategoryIdReject: null,
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
      pincode: "",
      companyName: "",
      address: ""
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.userData(id);
      this.fetchData();
    } else {
      console.error("No match params found.");
    }
  }

  userData = async (id) => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/jobs/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        }
      });
      if (response) {
        console.log(response.data);
        this.setState({
          title: response.data.title,
          category: response.data.category.name,
          areaInput: response.data.description,
          categoryId: response.data.category.id, // Corrected to use 'id' from the response
          salary: response?.data?.salary,
          currentImageUrl: response.data.image,
          pincode: response.data.pincode || "",
          companyName: response.data.companyName || "",
          address: response.data.address || ""
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/occupation`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      if (response.data) {
        this.setState({ categoryData: response.data.categories });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file), 
        });
      }
    });

    this.setState({ errors });
  };

  handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    const selectedCategory = this.state.categoryData.find(category => category._id === selectedCategoryId);

    if (selectedCategory) {
      this.setState({
        category: selectedCategory.name,
        categoryId: selectedCategory._id
      });
    } else {
      console.error(`Category with ID ${selectedCategoryId} not found`);
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ submeet: true });

    const { textInput, title, areaInput, categoryId, salary, pincode, companyName, address } = this.state;
    const { id } = this.props.match.params;

    try {
      const formData = new FormData();
      formData.append('image', textInput);
      formData.append('title', title);
      formData.append('description', areaInput);
      formData.append('category', categoryId);
      formData.append('salary', salary);
      formData.append('pincode', pincode);
      formData.append('companyName', companyName);
      formData.append('address', address);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`, 
        },
      };

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/jobs/${id}`, formData, config);

      if (response.status === 200) {
        this.setState({ submissionStatus: 'success', submeet: false });
        setTimeout(() => {
          this.props.history.push("/jobslist");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  render() {
    const { textInput, showModal, selectedCategoryId, categoryId,selectedCategoryIdReject, showModalReject, title, currentImageUrl, salary, userName, category, categoryData, submeet, areaInput, submissionStatus, pincode, companyName, address } = this.state;
    const isNameValid = userName.trim().length > 0;
    const isTitleValid = title?.trim()?.length > 0;
    const isSalaryValid = salary?.trim()?.length > 0;
    const isPincodeValid = pincode.trim().length > 0;
    const isCompanyNameValid = companyName.trim().length > 0;
    const isAddressValid = address.trim().length > 0;
  
    

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Job</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
            <div className="form-group">
        <label htmlFor="category">Category</label>
        <select
          className={`form-control ${submeet && !categoryId && "parsley-error"}`}
          value={categoryId}
          name="category"
          required
          onChange={this.handleCategoryChange}
        >
          <option value="" disabled>Select a category</option>
          {categoryData && categoryData.map((key) => (
            <option key={key._id} value={key._id}>{key.name}</option>
          ))}
        </select>
        {submeet && !categoryId ? (
          <ul className="parsley-errors-list filled" id="parsley-id-29">
            <li className="parsley-required">Category is required.</li>
          </ul>
        ) : null}
      </div>
              <div className="form-group">
                <label>Title</label>
                <input
                  className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                  value={title}
                  name="title"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ title: e.target.value });
                  }}
                />
                {!isTitleValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Image</label>

                {currentImageUrl && (
                  <div>
                    <img src={`https://uma-classees.blr1.digitaloceanspaces.com/${currentImageUrl}`} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control`}
                  name="textInput"
                  // required=""
                  onChange={this.handleChange}
                />
                {/* {!textInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null} */}
              </div>

              <div className="form-group">
                <label>Salary</label>
                <input
                  className={`form-control ${!isSalaryValid && submeet && "parsley-error"}`}
                  value={salary}
                  name="salary"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ salary: e.target.value });
                  }}
                />
                {!isSalaryValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Pincode</label>
                <input
                  className={`form-control ${!isPincodeValid && submeet && "parsley-error"}`}
                  value={pincode}
                  name="pincode"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ pincode: e.target.value });
                  }}
                />
                {submeet && !isPincodeValid ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Pincode is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Company Name</label>
                <input
                  className={`form-control ${!isCompanyNameValid && submeet && "parsley-error"}`}
                  value={companyName}
                  name="companyName"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ companyName: e.target.value });
                  }}
                />
                {submeet && !isCompanyNameValid ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Company Name is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Address</label>
                <textarea
                  className={`form-control ${!isAddressValid && submeet && "parsley-error"}`}
                  value={address}
                  name="address"
                  required=""
                  onChange={(e) => {
                    this.setState({ address: e.target.value });
                  }}
                />
                {submeet && !isAddressValid ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Address is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea
                  className={`form-control ${areaInput === "" && submeet && "parsley-error"
                    }`}
                  value={areaInput}
                  cols="30"
                  name="textarea"
                  required=""
                  rows="5"
                  onChange={(e) => {
                    this.setState({ areaInput: e.target.value });
                  }}
                ></textarea>
                {areaInput === "" && submeet ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
          <label>Actions</label><br></br>
          <div className="btn-group">
            <button type="button" className="btn btn-success" 
           onClick={() => this.handleApprove(category.id)}
            >
              Approve
            </button>&nbsp; &nbsp;&nbsp;
            <button type="button" className="btn btn-danger" onClick={() => this.handleReject(category.id)}>
              Reject
            </button>
          </div>
        </div>

              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
        <ConfirmApprovedModel
          show={showModal}
          handleClose={() => this.setState({ showModal: false })}
          handleConfirm={() => this.handleUpdate(selectedCategoryId)}
        />
        <ConfirmRejectModel
          show={showModalReject}
          handleClose={() => this.setState({ showModalReject: false })}
          handleConfirm={() => this.handleUpdateReject(selectedCategoryId)}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditJobs)); // Wrap with withRouter
